import { inject, injectable } from "inversify";
import type {
	IOrganisationSearchApplicationState,
	ISeoFilterState,
	ISeoInfoBase
} from "@studyportals/fawkes/organisations-search-seo";

import {
	types
} from "@studyportals/fawkes/organisations-search-seo";

import { FilterKey } from "@studyportals/search-filters";
import { Organisation } from "@/models/Organisation";
import { Store } from "@/store/Store";

@injectable()
export class SeoApplicationState implements IOrganisationSearchApplicationState {

	public constructor(
		@inject(types.SeoFilterState) private filterState: ISeoFilterState,
		@inject(types.SeoInfoBase) private seoInfoBase: ISeoInfoBase,
		private store: Store
	) { }

	public getNumberOfResults(): number {
		const totalResults = this.store.getters.getTotalSearchResults();

		if (!totalResults) {
			throw new Error("Total result count not available.");
		}

		return totalResults;
	}

	public getRankedResultsCount(): number {
		const organisations = this.store.getters.getOrganisations();

		const selectedValue = this.seoInfoBase.getFilterOptionValueBy(
			FilterKey.DISCIPLINES,
			this.filterState
		);

		if (!selectedValue) {
			return organisations.filter(o => o.globalMetaRankingPosition).length;
		}

		return this.getRankedResultsByDiscipline(
			organisations,
			Number(selectedValue)
		).length;
	}

	private getRankedResultsByDiscipline(
		organisations: readonly Organisation[],
		disciplineId: number
	): readonly Organisation[] {
		return organisations.filter(o => {
			const rankingPositions = o.metaRankingPositionsPerDiscipline;
			if (rankingPositions) {
				return rankingPositions.some(
					p => p.getDisciplineId() === disciplineId && p.getPosition() != null
				)
			}
		})
	}
}
